import { Stack } from "@mui/material";
import { styled } from "@mui/system";

export const StyledStack = styled(Stack)({
  overflowX: "auto",
  margin: "32px 8px",
});
